import React from 'react'

export function AdProduct() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g
        fill="#FFFFFF"
        fillRule="evenodd"
        clipPath="url(#clip0_3589_9238)"
        clipRule="evenodd"
      >
        <path d="M8.748.997a.563.563 0 01.504 0l7.5 3.75c.19.095.31.29.31.503v7.5c0 .213-.12.408-.31.503l-7.5 3.75a.562.562 0 01-.504 0l-7.5-3.75a.562.562 0 01-.31-.503v-7.5c0-.213.12-.408.31-.503l7.5-3.75zm-6.685 4.6v6.805L9 15.872l6.938-3.47V5.598L9 2.128l-6.938 3.47z" />
        <path d="M.997 4.998a.562.562 0 01.755-.251l7.5 3.75a.563.563 0 01-.503 1.006l-7.5-3.75a.563.563 0 01-.252-.755z" />
        <path d="M9 8.438c.31 0 .563.251.563.562v7.5a.562.562 0 11-1.126 0V9c0-.31.252-.563.563-.563z" />
        <path d="M17.003 4.998a.562.562 0 01-.251.755l-7.5 3.75a.563.563 0 01-.503-1.006l7.5-3.75a.562.562 0 01.754.251zM13.253 3.123a.562.562 0 01-.251.755l-7.5 3.75a.563.563 0 01-.503-1.006l7.5-3.75a.562.562 0 01.754.251z" />
      </g>
      <defs>
        <clipPath id="clip0_3589_9238">
          <path fill="#fff" d="M0 0H18V18H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
